export default __webpack_public_path__ + "static/assertions-05f025a23524c15d299b6908ba0b2749.gif";